import {showMain, pageTransition, showArticle} from './animations';
import {Router} from 'ninelines-router';

let router = new Router();

history.scrollRestoration = 'manual';

router.addRoute({
	path: '/',
	name: 'index',
	onEnter(prevState) {
		if (prevState.route === null) {
			return showMain();
		}

		return pageTransition(showMain);
	},
});

router.addRoute({
	path: '/article/:id',
	name: 'article',
	onEnter(prevState, currentState) {
		let id = currentState.params.id;

		if (prevState.route === null) {
			return showArticle(id);
		}

		return pageTransition(showArticle, id);
	},
});

router.on('notFound', () => {
	document.location.replace('/');
});

router.on('leave', () => {
	$(document).trigger('router-leave');

	return Promise.resolve();
});

router.start();

export {
	router,
};
